var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,7.5,25,14l-7,6.5","transform":"translate(-16.94 -6.44)","fill":"none","stroke":"#00C6CC","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.5"}));
}

Chevron.defaultProps = {"width":"8.81","height":"15.12","viewBox":"0 0 8.81 15.12"};

module.exports = Chevron;

Chevron.default = Chevron;
